import(/* webpackMode: "eager" */ "/app/app/layout.js");
